<template>
  <b-button
    :variant="isDisabled ? 'light' : 'primary'"
    :disabled="isDisabled || loading"
    class="!transition-all !duration-300"
    :class="{
      '!text-[#C2C2C2] !bg-[#F4F4F4] !border-[#E2E2E2]': isDisabled
    }"
    @click="$emit('cancel')"
  >
    <b-spinner
      v-if="loading"
      small
    />
    Batalkan Order
  </b-button>
</template>

<script>
export default {
  name: 'CancelOrderButton',
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cancelable: false,
      loading: false,
    }
  },
  computed: {
    isDisabled() {
      return !this.cancelable || this.status === 'Terkirim'
    },
  },
  beforeDestroy() {
    this.cancelable = false
    this.loading = false
  },
  methods: {
    /**
     * Sets the cancelable state for the button.
     * @public Exposed for parent access via $refs
     * @param {boolean} value - The new cancelable state
     */
    setCancelable(value) {
      this.cancelable = value
    },
    /**
     * Sets the loading state for the button.
     * @public Exposed for parent access via $refs
     * @param {boolean} value - The new loading state
     */
    setLoading(value) {
      this.loading = value
    },
  },
}
</script>
